import { Component, Input, ViewChild } from '@angular/core';
import { Workflow } from '../../Model/Dto/Workflow/Workflow';
import { WorkflowItem } from '../../Model/Dto/Workflow/WorkflowItem';
import { WorkflowService } from '../../Services/Workflow/workflow.service';
import { LoginService } from '../../Services/login.service';
import { ItemType } from '../ItemType';
import { Macro } from 'app/Model/ui/Macro';
import { FtpServer } from 'app/Model/FtpServer';
import { Template } from 'app/Model/Catalog/Template';
import { FtpServerService } from 'app/Services/ftp/ftpServer.service';
import { TemplateService } from 'app/Services/template.service';
import { ExportParameter } from 'app/Model/exportParameter/ExportParameter';
import { ExportConfigurationService } from 'app/Services/exportConfiguration.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'workflow-items',
  templateUrl: './workflow-items.component.html',
  styleUrl: './workflow-items.component.css'
})
export class WorkflowItemsComponent {
  @Input() workflow: Workflow = null;

  itemTypes: string[] = Object.values(ItemType);

  ftpServers: FtpServer[] = [];
  excelTemplates: Template[] = [];
  exportConfigs: ExportParameter[] = [];

  constructor(
    public workflowService: WorkflowService,
    public loginService: LoginService,
    public ftpServerService: FtpServerService,
    public templateService: TemplateService,
    public exportConfigurationService: ExportConfigurationService,
    public translate: TranslateService
  ) {
    this.onReorder = this.onReorder.bind(this);
    this.cellValueChanged = this.cellValueChanged.bind(this);

    this.ftpServerService.getAllServer().subscribe((ftpServer: FtpServer[]) => {
      this.ftpServers = ftpServer;
    });
    this.templateService.getTemplatesReturn().subscribe((templates: Template[]) => {
      this.excelTemplates = templates;
    });
    this.exportConfigurationService
      .getAll(this.loginService.currentCustomer.id)
      .subscribe((configs: ExportParameter[]) => {
        this.exportConfigs = configs.filter((x) => !x.isUpdateFilter);
      });
  }

  onReorder(e: any) {
    const data = e.component.option('dataSource');
    const fromIndex = e.fromIndex;
    const toIndex = e.toIndex;

    const fromItem = data[fromIndex];
    const toItem = data[toIndex];

    const tempOrder = fromItem.order;
    fromItem.order = toItem.order;
    toItem.order = tempOrder;

    data.sort((a, b) => a.order - b.order);
    e.component.option('dataSource', data);
    this.workflow.items = data;
    this.workflowService.updateOrCreateWorkflow(this.workflow, this.loginService.currentCustomer.id);
  }

  cellValueChanged(event: any) {
    this.workflowService.updateOrCreateWorkflow(this.workflow, this.loginService.currentCustomer.id);
  }

  removeItem(e: any) {
    const orderToDelete = e.data.order;
    this.workflow.items.forEach((item) => {
      if (item.order > orderToDelete) {
        item.order--;
      }
    });
    this.workflowService.updateOrCreateWorkflow(this.workflow, this.loginService.currentCustomer.id);
  }

  changeItemType(item: WorkflowItem, e: { name: string; parameter: string }) {
    if (e) {
      item.macroName = e.name;
      item.macroParameter = e.parameter;
    }
    this.workflowService.updateOrCreateWorkflow(this.workflow, this.loginService.currentCustomer.id);
  }

  getMarcoDesc(m) {
    if (m && m.macroName) {
      return m.macroName + 'Short';
    }
    return 'Bitte auswählen ...';
  }
}
